import $ from 'jquery'

export default function () {
  $('html')
    .removeClass('no-js')
    .addClass('js')
};



// WEBPACK FOOTER //
// ../htdocs/web/typo3conf/ext/vero/Resources/Public/JavaScript/Basic/js-enabled.js